/*
* State Data via Proxy
*
* Display, update information of SubAccount
**/

// Set initialState object

window.accountState = {
  user: {},
  orders: [],
  order: {},
}

export let state = window.accountState



// WEBPACK FOOTER //
// ./src/scripts/src/account/state.js